import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CacheService } from '../../services/cache/cache.service';
import { Sharing, SharingsResult } from '../interfaces';

@Injectable({
  providedIn: 'root'
})
export class SharingsDataService {

  private uri: string = `${environment.apiUrl}sharings`;
  private cacheKey: string = 'sharings.cache';

  constructor(
    private http: HttpClient,
    private cache: CacheService,
  ) {

  }

  getSharing(id: number): Observable<Sharing|any> {
    return this.http.get(this.uri + `/${id}`);
  }

  getSharings(parameters: {[param: string]: string | string[]}): Observable<SharingsResult|any> {
    return this.http.get(this.uri, {params: parameters});
  }

  addSharing(data: Sharing): Observable<Sharing|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.post(this.uri, cleanData);
  }

  addSharings(data: Sharing[]): Observable<Sharing[]|any> {
    this.clearCache();
    return this.http.post(this.uri + `/bulk`, data);
  }

  updateSharing(data: Sharing): Observable<Sharing|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.put(this.uri + `/${data.id}`, cleanData);
  }

  updateSharings(data: Sharing[]): Observable<Sharing[]|any> {
    this.clearCache();
    return this.http.put(this.uri + `/bulk`, data);
  }

  patchSharing(data: Sharing): Observable<Sharing|any> {
    this.clearCache();
    const cleanData = Object.assign({}, data);
    delete cleanData.id;
    return this.http.patch(this.uri + `/${data.id}`, cleanData);
  }

  patchSharings(data: Sharing[]): Observable<Sharing[]|any> {
    this.clearCache();
    return this.http.patch(this.uri + `/bulk`, data);
  }

  deleteSharing(data: Sharing): Observable<null|any> {
    this.clearCache();
    return this.http.delete(this.uri + `/${data.id}`);
  }

  deleteSharings(data: Sharing[]): Observable<null|any> {
    this.clearCache();
    const params: {ids: string} = {ids: ''};
    const ids: string[] = [];
    data.forEach((sharing) => {
      ids.push(sharing.id + '');
    });
    params.ids = ids.join(',');
    return this.http.delete(this.uri + `/bulk`, {params: params});
  }

  clearCache(): void {
    this.cache.remove(this.cacheKey);
  }

}
